import { useEffect, useRef, useState } from "react";
import * as echarts from "echarts";
import {
  Box,
  Paper,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import { useTranslation } from "react-i18next";

export default function MenuUsageChart({data}) {
  const { t } = useTranslation();

  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  // const [period, setPeriod] = useState("7d");

  // 📌 차트 초기화
  useEffect(() => {
    if (!chartRef.current) return;
    // chartInstance.current = echarts.init(chartRef.current);

    // return () => {
    //   chartInstance.current?.dispose();
    // };

    // console.log(chartRef.current);
    // console.log(chartInstance.current);

    if (!chartInstance.current) {
        chartInstance.current = echarts.init(chartRef.current);
    }
  }, []);

  // 📌 데이터 로딩
  useEffect(() => {
    try {
      // console.log(data)
      if (!data || data.length === 0) {
        console.warn("no data");
        return;
      }

      renderChart(data);
    } catch (err) {
      console.error("menu stats error", err);
    }
  }, []);

  useEffect(() => {
    const resize = () => chartInstance.current?.resize();
    window.addEventListener("resize", resize);

    return () => window.removeEventListener("resize", resize);
  }, []);

  useEffect(() => {
    const handleResize = () => {
        chartInstance.current?.resize();
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 📌 차트 렌더링
  const renderChart = (data) => {
    if (!chartInstance.current) return;

    const option = {
      title: {
        // text: "메뉴 사용 TOP 10",
        left: "left",
      },
      tooltip: {
        trigger: "axis",
      },
      grid: {
        left: "3%",
        right: "3%",
        top: "15%",
        bottom: "10%",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        data: data.map(d => t(d.menuName)),
        axisLabel: {
            rotate: 25,
            interval: 0
        }
      },
      yAxis: {
        type: "value",
      },
      series: [
        {
            type: "bar",
            data: data.map(d => d.viewCount),
            barMaxWidth: 40,   // 👈 중요 (이거 없으면 얇거나 이상함)
            itemStyle: {
                borderRadius: [6, 6, 0, 0]
            }
        }
      ],
    };

    chartInstance.current.setOption(option);

    // 📌 클릭 이벤트 (핵심)
    chartInstance.current.off("click");
    chartInstance.current.on("click", (params) => {
      const menuName = params.name;
      // console.log("클릭된 메뉴:", menuName);
    });
  };

  return (
    <Paper sx={{ p: 2, height: 450, display: "flex", flexDirection: "column" }}>
      <Box
        ref={chartRef}
        // sx={{ width: "100%", height: 400, border: "1px solid #ddd" }}
        sx={{
            flex: 1,
            width: "100%",
            minHeight: 0,
        }}
      />
    </Paper>
  );
}